// Copyright 2018 Sisense Inc. All rights reserved.

/**
 * @fileoverview Index file for Sisense module.
 * @copyright Sisense Inc.
 * @licence Sisense License.
 * @module @sbi/core
 */

'use strict';

/**
 * Exports of @sbi/utils module.
 * @type {Object}
 */
exports.utils = require('@sbi/core.utils');

/**
 * Exports of @sbi/events module.
 */
const { EventTarget, Event } = require('@sbi/core.events');
exports.events = {
    EventTarget,
    Event,
};

/**
 * Exports of @sbi/navigation module.
 * @type {Object}
 */
exports.navigation = require('@sbi/core.navigation');

/**
 * Exports of @sbi/components module.
 * @type {Object}
 */
exports.components = require('@sbi/core.components');
